// Angular
import { ChangeDetectionStrategy, Component } from '@angular/core';

// OLCI
import { LoaderService } from '../../loader.service';
import { BookingService } from '../../../core/services/booking.service';

@Component({
    selector: 'app-loading-container',
    templateUrl: 'loading-container.component.html',
    styleUrls: ['loading-container.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class LoadingContainerComponent {
	public brand: string;

	constructor(public loaderService: LoaderService, public bookingService: BookingService) {
		this.brand = this.bookingService.getBrand();
	}
}
